// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuItem_item__c\\+EWB Button {
  width: 100%;
  font-size: 16px;
}
.SideMenuItem_item__c\\+EWB Button p {
  width: 100%;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/common/SideMenu/SideMenuItem/SideMenuItem.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAIE;EACE,WAAA;EACA,eCJK;ADCT;AAKI;EACE,WAAA;EACA,gBAAA;AAHN","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.item {\n  Button {\n    width: 100%;\n    font-size: typography.$body-l;\n\n    p {\n      width: 100%;\n      text-align: left;\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `SideMenuItem_item__c+EWB`
};
export default ___CSS_LOADER_EXPORT___;
